export { LogoNoBelfiusText } from './LogoNoBelfiusText';
